import Container from '@/components/Container';
import Stepper from '@/components/Stepper';
import { getAuthentication } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import { QUERY_ONBOARDING } from '@edwin-group/people-graphql';
import type { OnBoardingQueryResult } from '../hooks/useOnBoardingV5';
import { useEffect } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';

export function OnboardingContainer() {
  const { stepNumber } = useParams<{ stepNumber: string }>();
  const currentStep = stepNumber ? parseInt(stepNumber, 10) : 1;
  const authentication = getAuthentication();
  const navigate = useNavigate();

  const { data } = useSuspenseQuery<OnBoardingQueryResult>(QUERY_ONBOARDING, {
    fetchPolicy: 'cache-first',
  });

  const totalSteps = data?.onBoardingPage?.steps?.length ?? 0;

  useEffect(() => {
    if (authentication?.user?.onboardHomeCompleted) {
      navigate('/', { replace: true });
    }
  }, [authentication?.user?.onboardHomeCompleted, navigate]);

  return (
    <Container>
      <div className="col-span-12 mt-sh-60 flex flex-col items-center justify-center px-4 md:col-start-3 md:col-end-11">
        {totalSteps > 0 && <Stepper steps={totalSteps} step={currentStep - 1} />}
        <Outlet />
      </div>
    </Container>
  );
}
